import { render, staticRenderFns } from "./IconPageBreak.vue?vue&type=template&id=c9b83fde&"
import script from "./IconPageBreak.vue?vue&type=script&lang=js&"
export * from "./IconPageBreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports